import _cloneDeep from 'lodash/cloneDeep';

export default {
  vehicleDetails: (state) => _cloneDeep(state.vehicleDetails),
  vehicleResults: (state) => _cloneDeep(state.vehicleResults),
  domicileResults: (state) => _cloneDeep(state.domicileResults),
  clientVehicleResults: (state) => _cloneDeep(state.vehicleResults),
};
